// Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
// Components
import Button from '../components/button';
// Actions

// Assets

class Test extends Component {
  render() {
    return (
      <div className="view view--landing">
        <div className="step">
          <Button to="/button">Start playing</Button>
        </div>
      </div>
    );
  }
}

export default connect()(Test);



/** WEBPACK FOOTER **
 ** ./src/js/containers/button.js
 **/